import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationIT from './locales/it/translation.json';

// Flatten the menu_detail structure to match component expectations
const flattenedTranslations = {
  ...translationIT.menu_detail,
  ...Object.fromEntries(
    Object.entries(translationIT).filter(([key]) => key !== 'menu_detail')
  )
};

// the translations
const resources = {
  it: {
    translation: flattenedTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'it', // Force Italian language
    fallbackLng: 'it',
    debug: true, // Enable to see translation logs
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;